import { useState, PropsWithChildren } from "react";
import { DialogResponsive } from "@/components/common/dialogs";

import { Provider } from "@/types";
import { Box } from "lucide-react";
import { FormCreateProvider } from "./form-create-provider";
import { FormUpdateProvider } from "./form-update-provider";

type FormUserProps = PropsWithChildren & {
  provider?: Provider;
};

export function FormProvider({ children, provider }: FormUserProps) {
  const [open, setOpen] = useState(false);
  return (
    <DialogResponsive
      title={provider ? "Atualizar fornecedor" : "Novo fornecedor"}
      titleIcon={<Box className="size-5" />}
      description={
        provider
          ? "Preencha os campos para atualizar o fornecedor."
          : "Preencha os campos para criar um novo fornecedor."
      }
      button={children}
      defaultOpen={open}
      setDefaultOpen={setOpen}
      className="max-w-5xl 2xl:max-w-6xl w-full h-auto"
    >

      {provider ? (
        <FormUpdateProvider
          provider={provider}
          handleClose={() => setOpen(false)}
        />
      ) : (
        <FormCreateProvider handleClose={() => setOpen(false)} />
      )}
    </DialogResponsive>
  );
}
